import { createSlice } from "@reduxjs/toolkit";
import { fetchTeacherScore } from "./operations.js";

const teacherScoreSlice = createSlice({
  name: "teacherScore",
  initialState: {
    pointsObject: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeacherScore.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTeacherScore.fulfilled, (state, action) => {
        state.loading = false;
        state.pointsObject = action.payload;
      })
      .addCase(fetchTeacherScore.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default teacherScoreSlice.reducer;
